// extracted by mini-css-extract-plugin
export default {"delta":"DeltaPill_delta__XI00N","pos":"DeltaPill_pos__rQJjA","neg":"DeltaPill_neg__cLcjg","flat":"DeltaPill_flat__N0gle","flatMark":"DeltaPill_flatMark__VVxgY"};